// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';
import { COLORS } from 'common/theme';

export const VirtualizationTypesContainer = styled.div`
    margin-top: 2px;
    color: ${COLORS.GREY_80};
`;
